export function parseOpsStatus(status) {
    status = status.toUpperCase();
    if (status == 'PRELAUNCH') {
        return 'pending';
    }
    if (status == 'ENDED' || status == 'RECAPPED') {
        return 'ended';
    }

    return 'in-progress';
}



// WEBPACK FOOTER //
// ./common/campaign_status_helper.js